import { css } from "styled-components";

export const basicLinkStyle = css`
  color: var(--link-default);
  background-color: var(--button-primary-default);
  font-weight: var(--font-weight-regular);
  border: 1px solid var(--button-primary-default) !important;

  svg:not([data-icon="loading"]) path {
    fill: transparent !important;
    stroke: var(--link-default) !important;
  }

  &:hover {
    background-color: var(--button-primary-default) !important;
    color: var(--link-hover) !important;
    border: 1px solid var(--button-primary-default) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--link-hover) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--link-default) !important;
    background-color: var(--button-primary-default) !important;
    border: 1px solid var(--button-primary-default) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--link-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-focused-shadow) !important;
    box-shadow: 0 0 0 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-primary-default) !important;
    color: var(--button-primary-clicked) !important;
    border: 1px solid var(--button-primary-default) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--button-primary-clicked) !important;
    }
  }

  &[disabled] {
    color: var(--link-default);
    background-color: var(--button-primary-default);
    border: 1px solid var(--button-primary-default) !important;
    opacity: 0.5;

    &:hover {
      color: var(--link-default);
      background-color: var(--button-primary-default);
      border: 1px solid var(--button-primary-default) !important;
      opacity: 0.5;
    }
  }
`;
